import type { Page } from 'skedyul-db'

/**
 * Team pages (memberId null) are visible to all workplace members.
 * Private pages are visible only to their owner.
 */
export const canAccessPage = (
  page: Pick<Page, 'memberId'>,
  memberId: string | null | undefined,
): boolean => {
  if (page.memberId === null || page.memberId === undefined) {
    return true
  }
  if (!memberId) {
    return false
  }
  return page.memberId === memberId
}

export const pageVisibility = (
  page: Pick<Page, 'memberId'>,
): 'team' | 'private' => {
  return page.memberId ? 'private' : 'team'
}
